"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _epics = _interopRequireDefault(require("settings-ui-sdk/Meetings/epics"));

var _root = _interopRequireDefault(require("settings-ui-sdk/Meetings/reducers/root"));

var _scopeChecks = require("settings-ui-lib/utils/scopeChecks");

var _AsyncContainers = require("./AsyncContainers");

var _strings = require("./constants/strings");

var _enums = require("./constants/enums");

var _default = {
  route: _UrlPathParams.MEETINGS,
  routes: _react.default.createElement(_reactRouter.Route, {
    path: _UrlPathParams.MEETINGS,
    component: _AsyncContainers.AsyncMeetingsContainer
  }, _react.default.createElement(_reactRouter.IndexRoute, {
    component: _AsyncContainers.AsyncSettingsContainer
  }), _react.default.createElement(_reactRouter.Route, {
    path: _strings.CALENDAR_ROUTE,
    selectedTab: _enums.SETTINGS_TABS.CALENDAR,
    component: _AsyncContainers.AsyncSettingsContainer
  }), _react.default.createElement(_reactRouter.Route, {
    path: _strings.DOMAIN_ROUTE,
    selectedTab: _enums.SETTINGS_TABS.DOMAIN,
    component: _AsyncContainers.AsyncSettingsContainer
  }), _react.default.createElement(_reactRouter.Route, {
    path: _strings.INTEGRATION_ROUTE,
    component: _AsyncContainers.AsyncIntegrationContainer
  })),
  reducer: _root.default,
  rootEpic: _epics.default,
  shouldModuleRender: (0, _scopeChecks.matchesAllScopes)(['sales-settings-access'])
};
exports.default = _default;
module.exports = exports.default;